export default __webpack_public_path__ + "static/media/lipstick-clear-spring.57240a46.png";